import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=c4335606&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=ts"
export * from "./pagination.vue?vue&type=script&lang=ts"
import style0 from "./pagination.vue?vue&type=style&index=0&id=c4335606&prod&lang=scss&scoped=true"
import style1 from "./pagination.vue?vue&type=style&index=1&id=c4335606&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4335606",
  null
  
)

export default component.exports